import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { cmsApi } from '../constants/constants'
import { oneAssetApi } from '../constants/constants'

@Injectable({
  providedIn: 'root'
})
export class FundService {

  private _FundWithFundTypeUrl: string = oneAssetApi + '/Fund/GetNAVDaily';

  constructor(private http: HttpClient) { }

  getTopFund() {
    const URL = cmsApi + '/get_fund_recomend';
    const body = {};
    return this.http.post(URL, body);
  }

  getAllFund() {
    const URL = cmsApi + '/get_fund_all';
    const body = {};
    return this.http.post(URL, body);
  }

  get_fundByName(name) {
    const URL = cmsApi + '/get_fundByName';
    const body = { name: name };
    return this.http.post(URL, body);
  }

  getFundIncludeFundType() {
    return this.http.get(this._FundWithFundTypeUrl)
  }

  getFundByTypeId(typeId: string) {
    const URL = cmsApi + '/get_fundByType';
    const body = {
      fundtype: typeId
    };
    return this.http.post(URL, body);
  }

  getFundInfo(fundInfoId: string) {
    const URL = oneAssetApi + '/Fund/GetInfo'
    const body = {
      fundId: fundInfoId
    }
    // console.log("getFundInfo body ", body);

    return this.http.post(URL, body)
  }

  getIIV() {
    const URL = oneAssetApi + '/info/GetIIV'
    return this.http.get(URL)
  }

  GetNAVHistory(fundId: string, fundCode: string) {
    const URL = oneAssetApi + '/Fund/GetNAVHistory'
    const body = {
      fundId: fundId,
      fundCode: fundCode
    }
    return this.http.post(URL, body)
  }

  getDevidendHistory(fundId: string) {
    const URL = oneAssetApi + '/Fund/GetWebFundInfoDivided'
    const body = {
      fundId: fundId
    }
    // console.log("getDevidendHistory ", body);
    return this.http.post(URL, body)
  }

  Graph(fundId: string, index: string) {
    const URL = oneAssetApi + '/Performance/Graph'
    const body = {
      fundId: fundId,
      index: index
    }
    return this.http.post(URL, body)
  }

  GetNAVBasket(FundId: string, date: string) {
    const URL = oneAssetApi + '/ETF/GetNAVBasket'
    const body = {
      FundId: FundId,
      date: date
    }
    return this.http.post(URL, body)
  }


  GetPDFBasket(FundId: string, date: string) {
    const URL = oneAssetApi + '/ETF/GetPDFBasket'
    const body = {
      FundId: FundId,
      date: date
    }
    // console.log(body);
    return this.http.post(URL, body)
  }


  getFundByFundId_Currency(FundId, currency) {
    const URL = cmsApi + '/getFundByFundId_Currency';
    const body = {
      FundId: FundId,
      currency: currency
    };
    return this.http.post(URL, body);
  }

  getFundDoc(fundId) {
    const URL = cmsApi + '/getDocByFundId2'
    const body = { id: fundId }
    // console.log(body);
    return this.http.post(URL, body)
  }

  getFundDocEN(fundId) {
    const URL = cmsApi + '/getDocByFundId2_en'
    const body = { id: fundId }
    // console.log(body);
    return this.http.post(URL, body)
  }

  getFundDocPrivate() {
    const URL = cmsApi + '/getDocumentPrivate_front'
    const body = { docName: '', IsActive: 'y' }
    // console.log(body);
    return this.http.post(URL, body)
  }

  getFundDocProvident() {
    const URL = cmsApi + '/getDocumentProvident_front'
    const body = { docName: '', IsActive: 'y' }
    // console.log(body);
    return this.http.post(URL, body)
  }

  getNavMovement(fundId, index, fundCode) {
    const URL = oneAssetApi + '/Fund/NAVMovement'
    const body = {
      fundId: fundId,
      index: index,
      fundCode: fundCode

    }

    return this.http.post(URL, body)
  }


  getNavMovement_2(fundId) {
    const URL = oneAssetApi + '/Fund/NAVMovement'
    const body = {
      fundId: fundId,
      fundcode: 'ONE-STOXXASEAN_USD',
      index: 3
    }

    return this.http.post(URL, body)
  }

  getCalendar(fundId) {
    const URL = cmsApi + '/getDocByFundId2_calendar'
    const body = { id: fundId }
    return this.http.post(URL, body)
  }

}
